import React from "react";
import "./Footer.css";

const Footer = () => {
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  const texts = {
    about: lang === "bn" ? "আমাদের সম্পর্কে" : "About Us",
    contact: lang === "bn" ? "যোগাযোগ করুন" : "Contact Us",
    privacy: lang === "bn" ? "গোপনীয়তা নীতি" : "Privacy Policy",
    terms: lang === "bn" ? "ব্যবহারের শর্তাবলী" : "Terms of Use",
    faq: lang === "bn" ? "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী" : "FAQ",
    description:
      lang === "bn"
        ? "Life in the UK Bangla অ্যাপটি বাংলাতে অনুদিত 'Life in the UK' পরীক্ষার প্রশ্ন সরবরাহ করে। যুক্তরাজ্যের নাগরিকত্ব পাওয়ার জন্য এটি একটি অত্যন্ত সহায়ক অ্যাপ।"
        : "Life in the Uk Bangla app provides translated Life in the UK test questions in Bangla. It's a helpful app for getting UK Citizenship.",
    download: lang === "bn" ? "ডাউনলোড করুন" : "Download",
  };

  return (
    <footer className="footer-container">
      <img
        src="/Assets/Logos/app_logo.png"
        alt="Logo"
        /* style={{ height: "100%" }} */
        className="footer-logo"
      />
      <div className="footer-content">
        <p
          className={`footer-description ${
            lang === "bn" ? "footer-bangla" : ""
          }`}
        >
          {texts.description}
        </p>
        <div className="footer-links">
          <a
            href="/about"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.about}
          </a>{" "}
          ‧
          <a
            href="/privacy"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.privacy}
          </a>{" "}
          ‧
          <a
            href="https://nuqisoft.com/contact/"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.contact}
          </a>
          {/* 
          
          <a
            href="/terms-of-use"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.terms}
          </a>
          <a
            href="/faq"
            className={`footer-link ${lang === "bn" ? "footer-bangla" : ""}`}
          >
            {texts.faq}
          </a> */}
        </div>
        <div className="footer-download">
          <a
            href="https://play.google.com/store/apps/details?id=com.nuqisoft.lifeintheukbangla"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-store-link"
          >
            <img
              src="/Assets/playstore.png"
              alt="Play Store"
              className="footer-store-icon"
            />
          </a>
          <a
            href="https://apps.apple.com/app/life-in-the-uk-bangla/id6760719138"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-store-link"
          >
            <img
              src="/Assets/appstore.png"
              alt="App Store"
              className="footer-store-icon"
            />
          </a>
        </div>
        <p className="footer-copyright">
          © {new Date().getFullYear()} Nuqisoft. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
